import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-fca-help-section',
    templateUrl: './fca-help-section.component.html',
    styleUrls: ['./fca-help-section.component.less'],
    standalone: false
})
export class FcaHelpSectionComponent implements OnInit {

  @Input() subscribedData1: any;

  constructor() { }

  ngOnInit(): void {
  }

}
